import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateMemberV2Component } from './activate-member-v2.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: ActivateMemberV2Component, data: { title: 'Activate contacts' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ActivateMemberV2RoutingModule { }
